import fixture from './UploadFile.post.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import { IPostInput, IPostResponse, IUploadFileClient } from 'interfaceAdapter/gatewaySchemas/IUploadFileClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/upload`;

export class UploadFileClient implements IUploadFileClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, category, formData, mock = false } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            ...(category === 'agent' ? { 'X-HTTP-AUTH-TOKEN-A': token } : {}),
            ...(category === 'company' ? { 'X-HTTP-AUTH-TOKEN-C': token } : {}),
            ...(category === 'buyer' ? { 'X-HTTP-AUTH-TOKEN-B': token } : {}),
            ...(category === 'supporter' ? { 'X-HTTP-AUTH-TOKEN-S': token } : {}),
        };
        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                      body: formData,
                  });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
